module.exports = __webpack_public_path__ + "static/media/Rainbow_Energized.c80ac571.gif";